import React from 'react';
import { Button, Icon, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

type Props = {
  entityType: string;
  entityId: string | number;
  floatingLabel?: React.ReactNode;
};

function DetailsButton({ entityType, entityId, floatingLabel }: Props) {
  return (
    <Link to={`${entityType}/${entityId}`} key={entityId}>
      <Segment basic className="segmentNoStyle">
        <Button icon size="tiny" display="block" basic>
          {floatingLabel}
          <Icon name="folder open" />
        </Button>
      </Segment>
    </Link>
  );
}

DetailsButton.defaultProps = {
  floatingLabel: null,
};

export default DetailsButton;
